<div class="bg-white">
  <div class="bg-e-white md:py-[50px] rounded-xl">
    <div class="container-default flex flex-col-reverse md:flex-row md:justify-between px-6">
      <div class="flex flex-col items-start justify-center md:w-1/3 md:me-6">
        <h1 class="" itemprop="name">{{_box?.title || _box?.name}}</h1>
        <h4 class="">{{_box?.subtitle}}</h4>
        <div class="my-5" [innerHTML]="_box?.shortdescription | safeHtml"></div>

        @if ((qtyeditable || repeatableeditable) && getBoxCountrypersonsprice()) {
        @if ((getBoxCountrypersonsprice()?.boxdiscountpercentage > 0 || getBoxCountrypersonsprice()?.boxdiscountamount > 0 )) {
        <div class="bg-e-gold text-white rounded-full px-2">
          <small>
            @if (getBoxCountrypersonsprice().boxdiscountpercentage) {
            {{calculatedPrice?.calculateddiscountpercentage}}% {{'common.discount' | translate}}
            } @else {
            {{calculatedPrice?.discountincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} {{'common.discount' | translate}}
            }
          </small>
        </div>
        }
        <pricetag class="p-0 col-6" [productprice]="true" [calculatedPrice]="calculatedPrice"></pricetag>
        @if (!repeatable.value && deliverydate) {
        <small class="text-secondary">{{'subscription.delivery_of' | translate}} {{deliverydate | localizedDate :'EEEE d MMMM' |lowercase}}</small>
        }
        @if (_box?.singleboxsellablefrom || _box?.singleboxsellableto) {
        <small>{{'box.deliverable_between'| translate: {from: _box?.boxPeriods[0]?.activefrom |localizedDate: 'd MMMM yyyy', to: _box?.boxPeriods[0]?.activeto|localizedDate: 'd MMMM yyyy' } }}</small>
        }
        <!--<small *ngIf="_box?.singleboxsellablefrom && _box.singleboxsellableto">{{'box.sellable_between'| translate: {from: _box?.singleboxsellablefrom |localizedDate: 'd MMMM yyyy', to: _box.singleboxsellableto|localizedDate: 'd MMMM yyyy' } }}</small>
          <small *ngIf="_box?.singleboxsellablefrom && !_box.singleboxsellableto">{{'box.sellable_from'| translate: {from: _box?.singleboxsellablefrom |localizedDate: 'd MMMM yyyy'} }}</small>
          <small *ngIf="!_box?.singleboxsellablefrom && _box.singleboxsellableto">{{'box.sellable_to'| translate: {to: _box?.singleboxsellableto |localizedDate: 'd MMMM yyyy'} }}</small>-->
        <div class="flex w-full justify-between mt-6">
          <span class="my-auto me-2">{{'common.quantity' | translate}}</span>
          <app-quantityselection class="w-2/3" [quantity]="quantity.value" (quantityChange)="setQuantity($event)" [contrastColorscheme]="colorscheme"></app-quantityselection>
        </div>
        @if (personseditable) {
        <div class="flex w-full justify-between mt-6">
          <span class="my-auto me-2">{{'common.person' | translate}}</span>
          <app-personselection class="w-2/3" [contrastColorscheme]="colorscheme" [persons]="persons.value" (personsChange)="setPersonQuantity($event)"
            [personsoptions]="_box?._boxpersons" [doublepersons]="_box?.doublepersons">
            <!--<span>{{'common.person_abbr'|translate}}</span>-->
          </app-personselection>
        </div>
        }
        @if (repeatableeditable) {
        <app-toggle class="ms-2 mt-6" [formControl]="repeatable" color="success">{{'subscription.product_weekly' | translate}}</app-toggle>
        }
        }
        @if (!qtyeditable && quantity.value !== 0) {
        <div>
          <small>{{'common.piece' |translate : {count: quantity.value} }}</small>
        </div>
        }
        @if (!personseditable ) {
        <div class="mt-3">
          <small>{{_box?.doublepersons? persons.value * 2 : persons.value}} {{'common.person'|translate}}</small>
        </div>
        }
      </div>

      <div class="md:w-2/3">
        <app-image [imageobject]="_box" size="lg" alt="{{_box?.title}}" class="rounded-3xl object-cover w-full"></app-image>
      </div>
    </div>
    <div class="hidden md:flex w-[39px] h-[39px] icon-round mx-auto mt-6">
      <img _ngcontent-serverapp-c211="" src="./assets/images/icons/arrow_down.svg" class="h-5 w-5">
    </div>
  </div>
  <div class="container-default flex flex-col flex-wrap px-6 mt-6">
    <div class="w-full mt-6" [innerHTML]="_box?.description | safeHtml"></div>

    <h2 class="mx-2 mt-6">{{'box.content' | translate}}</h2>

    @if (_box?.boxPeriods && _box?.boxPeriods.length>0) {
        <div class="flex flex-col md:flex-row gap-6 mb-6">
          <recipe-list [recipes]="recipes" class="w-full" [ngClass]="{'md:w-3/5': _box?.boxPeriods[0].boxProducts.length >0}">
            <ng-template #recipe let-recipe>
              <recipecard [recipe]="recipe" colorscheme="light"> </recipecard>
            </ng-template>
          </recipe-list>
          @if (_box?.boxPeriods[0].boxProducts.length >0) {
          <div class="w-full md:w-2/5">
            <div class="bg-e-white rounded-xl p-6">
              <h2>{{'box.extraproducts' | translate}}</h2>
              <app-ingredientlist [doublepersons]="_box?.doublepersons" [personquantity]="persons.value" [personsoptions]="_box?._boxpersons" [ingredients]="_box?.boxPeriods[0].boxProducts"></app-ingredientlist>
            </div>
          </div>

          }
       
      

    </div>
    }@else {
    <span>{{'box.content_not_filled_yet' |translate}}</span>
    }
  </div>



</div>